import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ScheduleApiModel, ScheduleListApiModel, DateRangeApiModel } from '@app/api/api-models';
import { ProgramUserListApiModel } from '@app/api/api-models/users/program-users-list/ProgramUserListApiModel';
import { ProgramRole } from '@app/shared/enums';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ScheduleService {
  public apiUrl = 'schedule';

  constructor(private http: HttpClientService) {}

  public getByRole(programRole: ProgramRole): Observable<Array<ScheduleListApiModel>> {
    return this.http.get<Array<ScheduleListApiModel>>(`${this.apiUrl}/get-by-role/${programRole}`);
  }

  public getByProgramRoleId(programRoleId: string): Observable<Array<ScheduleApiModel>> {
    return this.http
      .get<Array<ScheduleApiModel>>(`${this.apiUrl}/get-by-program-role-id/${programRoleId}`)
      .pipe(map((data) => data.map((item) => new ScheduleApiModel().deserialize(item))));
  }

  public getMyCalendar(programRoleId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/get-my-calendar/${programRoleId}`, { responseType: 'blob' });
  }

  public getPdf(programRoleId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/get-pdf/${programRoleId}`, { responseType: 'blob' });
  }

  public apply(programRoleId: string, scheduleList: Array<ScheduleApiModel>): Observable<Array<ScheduleApiModel>> {
    return this.http
      .post<Array<ScheduleApiModel>>(`${this.apiUrl}/apply/${programRoleId}`, scheduleList)
      .pipe(map((data) => data.map((item) => new ScheduleApiModel().deserialize(item))));
  }

  public getForbiddenDates(
    targetUserProgramRoleId: string,
    programRoleIds: string[]
  ): Observable<Array<DateRangeApiModel>> {
    return this.http
      .post<Array<DateRangeApiModel>>(`${this.apiUrl}/get-forbidden-dates/${targetUserProgramRoleId}`, programRoleIds)
      .pipe(map((data) => data.map((item) => new DateRangeApiModel().deserialize(item))));
  }

  public getActiveUsers(role: ProgramRole): Observable<ProgramUserListApiModel[]> {
    return this.http
      .get<ProgramUserListApiModel[]>(`${this.apiUrl}/get-active-users/${role}`)
      .pipe(map((array) => array.map((x) => new ProgramUserListApiModel().deserialize(x))));
  }
}
